import { connect } from "react-redux";
import { closePortfolioModal, openPortfolioDeleteModal, savePortfolio } from "actions/portfolio";
import { withFormik } from "formik";
import pick from "lodash/pick";

import PortfolioModal from "./PortfolioModal";

const form = withFormik({
  displayName: "portfolio",
  enableReinitialize: true,
  mapPropsToValues: ({ portfolio }) => ({
    ...pick(portfolio, ["id", "name", "type"]),
  }),
  handleSubmit: (values, { props: { onSubmit } }) => onSubmit(values),
})(PortfolioModal);

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(closePortfolioModal()),
  onDelete: () => dispatch(openPortfolioDeleteModal()),
  onSubmit: (portfolio) => dispatch(savePortfolio(portfolio)),
});

const mapStateToProps = ({ isPortfolioModalOpen, loading, portfolios }) => {
  const portfolio = portfolios.find((p) => p.isEdit) || {};

  return {
    portfolio,
    isOpen: isPortfolioModalOpen,
    isEdit: !!portfolio.id,
    isLoading: loading.portfolio,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(form);
